import * as orderApi from '../../api/order-api';
import { IAccount } from '../../models/company-account';
import {
    ICancelReasonItem,
    IDeleteLine,
    IEscalateOrder,
    ILineItemAdd,
    IOrderCancellation,
    IOrderDetails,
    IOrderDetailsLine,
    IOrderDLineNumOpts,
    IOrderDropShip,
    IOrderHistoryLine,
    IOrderHistoryRequest,
    IOrderHistoryResult,
    IOrderUpdateShipTo,
    IRelatedItems,
    IUpdateOptionData,
} from '../../models/order';
import { IITAPISResult, IResult } from '../../models/result-models';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_ORDER_SUCCESS = 'LOAD_ORDER_SUCCESS';
export const LOAD_ORDER_ERROR = 'LOAD_ORDER_ERROR';

export const LOAD_ORDERS_SUCCESS = 'LOAD_ORDERS_SUCCESS';
export const LOAD_ORDERS_ERROR = 'LOAD_ORDERS_ERROR';

export const REORDER_SUCCESS = 'REORDER_SUCCESS';
export const REORDER_ERROR = 'REORDER_ERROR';

export const CANCEL_REASONS_SUCCESS = 'CANCEL_REASONS_SUCCESS';
export const CANCEL_REASONS_ERROR = 'CANCEL_REASONS_ERROR';

export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_ERROR = 'CANCEL_ORDER_ERROR';

export const UPDATE_SHIPTO_SUCCESS = 'UPDATE_SHIPTO_SUCCESS';
export const UPDATE_SHIPTO_ERROR = 'UPDATE_SHIPTO_ERROR';

export const UPDATE_DELIVERTO_SUCCESS = 'UPDATE_DELIVERTO_SUCCESS';
export const UPDATE_DELIVERTO_ERROR = 'UPDATE_DELIVERTO_ERROR';
export const CLEAR_DELIVERTO = 'CLEAR_DELIVERTO';

export const UPDATE_BILLTO_SUCCESS = 'UPDATE_BILLTO_SUCCESS';
export const UPDATE_BILLTO_ERROR = 'UPDATE_BILLTO_ERROR';

export const DELETE_LINEITEM_SUCCESS = 'DELETE_LINEITEM_SUCCESS';
export const DELETE_LINEITEM_ERROR = 'DELETE_LINEITEM_ERROR';

export const GET_RELATED_ITEMS_SUCCESS = 'GET_RELATED_ITEMS_SUCCESS';
export const GET_RELATED_ITEMS_ERROR = 'GET_RELATED_ITEMS_ERROR';
export const CLEAR_RELATED_ITEMS = 'CLEAR_RELATED_ITEMS';

export const ADD_ITEMS_SUCCESS = 'ADD_ITEMS_SUCCESS';
export const ADD_ITEMS_ERROR = 'ADD_ITEMS_ERROR';
export const CLEAR_ADD_ITEMS = 'CLEAR_ADD_ITEMS';

export const POST_ESCALATION_SUCCESS = 'POST_ESCALATION_SUCCESS';
export const POST_ESCALATION_ERROR = 'POST_ESCALATION_ERROR';
export const RESET_ESCALATION_STATUS = 'RESET_ESCALATION_STATUS';

export const LINE_ITEM_PT_TRUE = 'LINE_ITEM_PT_TRUE';
export const LINE_ITEM_PT_FALSE = 'LINE_ITEM_PT_FALSE';

export const CLEAR_REORDER = 'CLEAR_REORDER';

export const UPDATE_OPTION_DATA = 'UPDATE_OPTION_DATA';
export const CLEAR_OPTION_DATA = 'CLEAR_OPTION_DATA';

export const ADJUST_FEATURES_SUCCESS = 'ADJUST_FEATURES_SUCCESS';
export const ADJUST_FEATURES_ERROR = 'ADJUST_FEATURES_ERROR';
export const CLEAR_ADJUST_FEATURES = 'CLEAR_ADJUST_FEATURES';
export const UPDATE_SELECT = 'UPDATE_SELECT';

export const ORDER_HISTORY_REQUEST = 'ORDER_HISTORY_REQUEST';
export const CLEAR_ORDER_HISTORY_REQUEST = 'CLEAR_ORDER_HISTORY_REQUEST';

export const loadOrderSuccess = (result: IResult<IOrderDetails>) => ({
    type: LOAD_ORDER_SUCCESS,
    result,
});

export const loadOrdersSuccess = (result: IResult<IOrderHistoryResult>) => ({
    type: LOAD_ORDERS_SUCCESS,
    result,
});

export const reorderSuccess = (result: IResult<boolean>) => ({
    type: REORDER_SUCCESS,
    result,
});
export const clearReorder = () => ({
    type: CLEAR_REORDER,
});

export const cancelReasonsSuccess = (result: IResult<ICancelReasonItem[]>) => ({
    type: CANCEL_REASONS_SUCCESS,
    result,
});
export const cancelOrderSuccess = (result: IResult<IITAPISResult>) => ({
    type: CANCEL_ORDER_SUCCESS,
    result,
});
export const cancelOrderError = (result: IResult<IITAPISResult>) => ({
    type: CANCEL_ORDER_ERROR,
    result,
});
export const updateShipToSuccess = (result: IResult<boolean>) => ({
    type: UPDATE_SHIPTO_SUCCESS,
    result,
});

export const updateDeliverToSuccess = (result: IResult<IITAPISResult>) => ({
    type: UPDATE_DELIVERTO_SUCCESS,
    result,
});
export const clearDeliverTo = () => ({
    type: CLEAR_DELIVERTO,
});

export const deleteLineItemSuccess = (result: IResult<IITAPISResult>) => ({
    type: DELETE_LINEITEM_SUCCESS,
    result,
});

export const updateBillToSuccess = (result: IResult<boolean>) => ({
    type: UPDATE_BILLTO_SUCCESS,
    result,
});

export const getRelatedItemsSuccess = (result: IResult<IRelatedItems>) => ({
    type: GET_RELATED_ITEMS_SUCCESS,
    result,
});
export const clearRelatedItemsCall = () => ({
    type: CLEAR_RELATED_ITEMS,
});
export const addItemsSuccess = (result: IResult<IITAPISResult>) => ({
    type: ADD_ITEMS_SUCCESS,
    result,
});
export const clearAddItemsCall = () => ({
    type: CLEAR_ADD_ITEMS,
});

export const postEscalationSuccess = (result: IResult<string>) => ({
    type: POST_ESCALATION_SUCCESS,
    result,
});

export const resetEscalationStatus = () => ({
    type: RESET_ESCALATION_STATUS,
});
export const lineItemPTTrue = () => ({
    type: LINE_ITEM_PT_TRUE,
});
export const lineItemPTFalse = () => ({
    type: LINE_ITEM_PT_FALSE,
});

export const updateOptionData = (result: IUpdateOptionData) => ({
    type: UPDATE_OPTION_DATA,
    result,
});
export const clearOptionData = () => ({
    type: CLEAR_OPTION_DATA,
});

export const adjustFeaturesSuccess = (result: IResult<IITAPISResult>) => ({
    type: ADJUST_FEATURES_SUCCESS,
    result,
});
export const clearAdjustFeatures = () => ({
    type: CLEAR_ADJUST_FEATURES,
});
export const updateSelect = (result: number) => ({
    type: UPDATE_SELECT,
    result,
});
export const setOrderHistoryRequest = (result: IOrderHistoryRequest) => ({
    type: ORDER_HISTORY_REQUEST,
    result,
});
// Thunks
export const loadOrder = (orderNumber: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.getOrder(orderNumber);
            dispatch(loadOrderSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const loadOrders = (request: IOrderHistoryRequest) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.orderHistorySearch(request);
            dispatch(loadOrdersSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const reorder = (
    lineItems: IOrderDetailsLine[],
    orderNumber: string
) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.reorder(lineItems, orderNumber);
            dispatch(reorderSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const cancelOrder = (orderToCancel: IOrderCancellation) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.cancelOrder(orderToCancel);
            dispatch(cancelOrderSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const loadCancelReasons = () => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.cancelReasons();
            dispatch(cancelReasonsSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
export const updateShipTo = (updatedShipTo: IOrderUpdateShipTo) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.changeShipTo(updatedShipTo);
            dispatch(updateShipToSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const updateDeliverTo = (
    address: IOrderDropShip,
    orderNumber: string
) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.changeDeliverTo(address, orderNumber);
            dispatch(updateDeliverToSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const updateBillTo = (updatedBillTo: IAccount) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.changeBillTo(updatedBillTo);
            dispatch(updateBillToSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const deleteLineItem = (lineItemToDelete: IDeleteLine) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.deleteLine(lineItemToDelete);
            dispatch(deleteLineItemSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const postLineToGetRelatedItems = (parts: string[]) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.getRelatedItemsFromOrder(parts);
            dispatch(getRelatedItemsSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
export const clearRelatedItems = () => {
    return async (dispatch: any) => {
        try {
            dispatch(clearRelatedItemsCall());
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const addItemsFromLine = (items: ILineItemAdd) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.addItems(items);
            dispatch(addItemsSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const escalateOrder = (order: IEscalateOrder) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await orderApi.postEscalation(order);
            dispatch(postEscalationSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
export const adjustFeaturesAction = (
    isEarmold: boolean,
    orderNumber: string,
    items: IOrderDLineNumOpts[]
) => {
    return async (dispatch: any) => {
        if (isEarmold) {
            try {
                dispatch(beginApiCall());
                const result = await orderApi.adjustFeaturesEarmold(
                    orderNumber,
                    items
                );
                dispatch(adjustFeaturesSuccess(result));
            } catch (error) {
                dispatch(apiCallError(error));
                throw error;
            }
            return;
        }
        try {
            dispatch(beginApiCall());
            const result = await orderApi.adjustFeaturesStandard(
                orderNumber,
                items
            );
            dispatch(adjustFeaturesSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
